import type { StickerAPIInterface } from './api-switcher'
import { client } from './client'

export const StickerAPI: StickerAPIInterface = {
  getRemoveBgUrl: (photo, signal) =>
    client.POST('/my/{PhotoId}/sticker', {
      params: { path: { PhotoId: photo.photo_id } },
      signal,
    }),
}
